import React from 'react';
import { useHistory } from 'react-router-dom';
import { Nullable } from 'src/types/nullable.type';

type Props = {
  headerSection: Nullable<string | JSX.Element>;
  contentSection: Nullable<string | JSX.Element>;
};


export const DashboardInsightsItemLayout = ({
  headerSection,
  contentSection,
}: Props) => {
  const history = useHistory();
  return (
    <>
      <div className='flex flex-col w-full'>
        <div className='flex flex-col gap-6'>
        
          <div className='flex flex-col items-start pb-0 bg-bedrock-white insights-overview'>
            {headerSection}
          
            <div className='mt-12 w-full min-h-[40vh]'>{contentSection}</div>
          </div>
        </div>
      </div>
    </>
  );
};
